import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
/**
 * State：定义了应用状态的数据结构，可以在这里设置默认的初始状态。
 * Getter：允许组件从 Store 中获取数据，mapGetters 辅助函数仅仅是将 store 中的 getter 映射到局部计算属性。
 * Mutation：是唯一更改 store 中状态的方法，且必须是同步函数。
 * Action：用于提交 mutation，而不是直接变更状态，可以包含任意异步操作。
 * Module：可以将 store 分割成模块（module）。每个模块拥有自己的 state、mutation、action、getter、甚至是嵌套子模块——从上至下进行同样方式的分割
 **/
const store = new Vuex.Store({
  state: {
    userInfo: {},
    userExt: {},
    token: '',
    refreshCart: false,
    demand: '',
    searchValue: '',
    actionLink: {},
    categoryData: JSON.parse(localStorage.getItem('category')) || [],
    showDetails: localStorage.getItem('showDetails') || false,
    addressShow: false,
    addressList: []
  },
  mutations: {
    // 刷新购物车
    refreshCart(state, isRefresh) {
      state.refreshCart = isRefresh
    },
    SET_DEMAND(state, demand) {
      state.demand = demand
    },
    SET_SEARCHVALUE(state, searchValue) {
      state.searchValue = searchValue
    },
    SET_ACTIONLINK(state, actionLink) {
      state.actionLink = actionLink
    },
    SET_CATEGORYDATA(state, data) {
      state.categoryData = data
      localStorage.setItem('category', JSON.stringify(data))
    },
    setShowDetails(state, data) {
      state.showDetails = data
      localStorage.setItem('showDetails', JSON.stringify(data))
    },
    SET_USER(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    CLEAR_USER(state) {
      state.userInfo = null
    },
    SET_ADDRESS(state, addr) {
      state.addressList = addr
    },
    CLEAR_ADDRESS(state) {
      state.addressList = []
    },
    SET_ADDR_SHOW(state, show) {
      state.addressShow = show
    }
  },
  actions: {

  },
  getters: {
    getDemand(state) {
      return state.demand;
    },
    getActionLink(state) {
      return state.actionLink;
    },
    getCategoryData(state) {
      return state.categoryData
    },
    showDetails(state) {
      return state.showDetails
    }
  },
  plugins: [createPersistedState()]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js